import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Button } from 'reactstrap';
import SlidingPane from 'react-sliding-pane';
import 'react-sliding-pane/dist/react-sliding-pane.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faMapPin } from '@fortawesome/free-solid-svg-icons';
import { fetchSharedPlanoCampaigns, setViewCampaignPane, exportExcel, setApprovalStatus } from '../../actions/planoCampaignActions';
import Map from '../campaign/maps';

library.add(faMapPin);

class SharedCampaign extends Component {

    state = {

    }

    componentWillMount() {
        this.props.fetchSharedPlanoCampaigns();
    }

    handleViewCampaign = (item)=>{
        this.props.setViewCampaignPane(item);
    }

    handleCloseViewCampaign = ()=>{
        this.props.setViewCampaignPane({});
    }

    handleExportButton = (item)=>{
        this.props.exportExcel(item);
    }

    handleApprovalButton = (approval_status, campaign_id) => {
        this.props.setApprovalStatus(approval_status, campaign_id);
    }

    render() {


        let showCampaignDetails = false;
        let title = "";
        let subtitle = "";

        const { campaignName, startDate, endDate } = this.props.viewCampaignItem;

        if(campaignName){
            showCampaignDetails = true;
            title = campaignName;
            subtitle = "Start Date : "+startDate+", End Date : "+endDate
        }

        return (
            <div style={{ width: "100%", margin: "5px" }}>
                <Table responsive hover bordered striped>
                    <thead>
                        <tr>
                            <th>Campaign Name</th>
                            <th>Start Date</th>
                            <th>End Date</th>
                            <th>Map</th>
                            {/* <th>Delete</th> */}
                            <th>Download Excel</th>
                            <th>Approve/Disapprove</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.props.sharedPlanoCampaigns.map((item, index) => {
                                const {campaignName, startDate, endDate, isApproved} = item;
                                return (
                                    <tr key={index}>
                                        <td>{campaignName}</td>
                                        <td>{startDate}</td>
                                        <td>{endDate}</td>
                                        <td><Button onClick={this.handleViewCampaign.bind(this, item)} color="info">View <FontAwesomeIcon icon="map-pin"/></Button></td>
                                        <td><Button color="info" onClick={this.handleExportButton.bind(this, item)}>Export </Button></td>
                                        <td><Button onClick={this.handleApprovalButton.bind(this, !isApproved, item._id)} color={isApproved ? "danger" : "success"}>{isApproved ? "Disapprove" : "Approve" }</Button></td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </Table> 
                {
                    showCampaignDetails && 
                    <SlidingPane isOpen={showCampaignDetails} onRequestClose={ this.handleCloseViewCampaign } title={title} subtitle={subtitle}>
                        <Map
                            loadingElement={<div style={{ height: `100%` }} />}
                            containerElement={<div style={{ height: '90vh', width: '75vw' }} />}
                            mapElement={<div style={{ height: `100%` }} />}
                            center={this.props.center}
                            viewCampaignItem={this.props.viewCampaignItem}/>
                    </SlidingPane>
                }
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        sharedPlanoCampaigns: state.planoCampaigns.sharedPlanoCampaigns,
        viewCampaignItem : state.planoCampaigns.viewCampaignItem
    }
}

export default connect(mapStateToProps, { fetchSharedPlanoCampaigns, setViewCampaignPane, exportExcel, setApprovalStatus })(SharedCampaign);


// WEBPACK FOOTER //
// ./src/v3/components/sharedCampaign/sharedCampaign.js